export class DocumentViewerModel
{
    public url: string;
    public name: string;
    public description: string;
    public createdOn: string;
    public content: any;
    public image: string;
    public mediaType: string;
    public memberId: number;
    public isCDA: boolean;

    constructor()
    {
        this.content = '';
        this.url = '';
        this.name = '';
        this.description = '';
        this.createdOn = '';
        this.content = '';
        this.image = '';
        this.mediaType = '';
        this.memberId = 0;
        this.isCDA = false;
    }
}
